var lastRoutePosted = "";
var pageNum = 1;
var lastDatePosted = null;
var even = true; 
function getMore(lastItem){
	var url = '/getmore';
	var contentTypes = ["Petition","Article"];
	if(typeof lastItem != 'undefined' && lastRoutePosted == ""){
		lastRoutePosted = lastItem.route;
		lastDatePosted = new Date(lastItem.published);
	}
	var topics = [];
	topics.push(lastItem.topicTag);
	var pageSize = 20;
	pageNum++;

	$.ajax({
		url:url,
		data:{
			contentTypes:contentTypes,
			pageSize:pageSize,
			pageNum:pageNum,
			topics:topics
		},
		success: function(data){
			if(data.Content.length > 0){
				for(var i = 0; i < data.Content.length; i++){
					var curDate = new Date(data.Content[i].published);
					if(curDate.getMonth() != lastDatePosted.getMonth() || curDate.getFullYear() != lastDatePosted.getFullYear())
						$('#topicContainer').append(createLineBreak(curDate));
					$('.topicList:last-child').append(createWidget(data.Content[i]));
					lastDatePosted = new Date(data.Content[i].published);
					if(data.Content[i].contentType == 'Petition'){
						var petitionId = data.Content[i].id || data.Content[i]._id; 
						initializeCounter($("#SignatureCounter"+petitionId),petitionId);
					}
				}
			}
			if(data.Content.length < pageSize) {
				$('.readMoreContainer').parent().hide();
			}
			function createLineBreak(date){
				var month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
				var htmlString = '<div class="lineBreakContainer"><div class="lineBreak dateSectionDivider"></div><div class="lineBreakTextContainer"><div class="topicTags dateSectionDivider">';
				htmlString += (date.getFullYear() != new Date().getFullYear()) ? (month[date.getMonth()] + ' ' + date.getFullYear()) : month[date.getMonth()];
				return htmlString += '</div></div></div><div class="row topicList"></div>';
			}
			function createWidget(item){
				var petitionLinkClass = "";
				var signatureContainer = "";
				var authorHtml = "";
				var actionLink = "";
				var summaryLength = 0;
				var imageHtml = "";
				var scriptContent = "";
				if(typeof item.image != "undefined" && item.image != ""){
					var imageUrl = (typeof item.featuredYoutube != 'undefined' && item.featuredYoutube != "") ? '//img.youtube.com/vi/' + item.featuredYoutube + '/mqdefault.jpg' : getImageUrl(item,"quarter");
					imageHtml = '<a href="/'+item.route+'"><img class="img-responsive" src="'+imageUrl+'" /></a>';
				}
				if(item.contentType == 'Article'){
					summaryLength = 300;
					if(typeof item.author != 'undefined'){
						var authorUrl = item.author.replace(/ /g, '-').replace(/\.org/g,'-staff').replace(/\./g,'').toLowerCase();
						authorHtml = '<span class="authorTag">By <a href="/writers/'+authorUrl+'">'+item.author+'</a></span>';
					}
					actionLink = '<a class="readMore" href="/' + item.route +'">read more</a>';
				}
				if(item.contentType == 'Petition'){
					var petitionId = item.id || item._id;
					summaryLength = 200;
					petitionLinkClass = ' petitionLink';
					signatureContainer = '<div class="signatureContainer"><span class="SignatureCounter" id="SignatureCounter' + petitionId + '"></span><span>&nbsp;&nbsp;Signatures</span></div>';
					actionLink = '<a class="signButton" href="/' + item.route +'">SIGN</a>';
					
				}
				item.copySummary = cleanseCopy(item.copy,summaryLength);
				var title = (typeof item.shortTitle != 'undefined' && item.shortTitle != '') ? item.shortTitle : item.title;


				return '<div class="col-md-3 col-sm-6 col-xs-12"><div class="contentItem article'+petitionLinkClass+
								'"><div><div class="contentItemImgContainer">'+imageHtml+signatureContainer+'</div></div><div class="contentItemContent"><h2><a href="'+item.route+
								'">'+title+'</a></h2>'+authorHtml+'<span class="timestamp">'+calculateTime(item.published)+'</span><div class="clearFloat"></div><div class="articleCopy"><p>'+
								item.copySummary +'</p></div>'+actionLink+'</div></div></div>';
			}
		},
		dataType: 'json'
	});
}